import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import NameSchema, { NameJSON, NameParams } from "_shared/names/name-schema";

export default class Name {
  public static create(args: { params: NameParams, options?: { silenceSchemaErrors: boolean } }): Name {
    const parsed = NameSchema.validate(args.params, !args.options?.silenceSchemaErrors);
    if (isNullOrUndefined(parsed)) {
      throw new InvalidNameError("Invalid name parameters.", {
        firstName: args.params.firstName ?? "undefined",
        lastName: args.params.lastName ?? "undefined",
      });
    }
    return new Name(parsed);
  }

  public static fromJSON(json: unknown): Name | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const parsed = NameSchema.deserialize(json);
    return new Name(parsed);
  }

  public readonly firstName?: string;
  public readonly lastName?: string;

  public toJSON(): NameJSON {
    return NameSchema.serialize(this);
  }

  public get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  public get initials(): string {
    return (`${this.firstName?.charAt(0)}` + `${this.lastName?.charAt(0)}`).toUpperCase();
  }

  public isEqualTo(other: Name | null | undefined): boolean {
    return this.firstName === other?.firstName && this.lastName === other?.lastName;
  }

  public toString(): string {
    return `Name (
      firstName: ${this.firstName} 
      lastName: ${this.lastName}
    )`;
  }

  public constructor(values: NameParams) {
    this.firstName = values.firstName;
    this.lastName = values.lastName;
  }
}

export class InvalidNameError extends Error {
  public readonly firstName: string;
  public readonly lastName: string;
  constructor(message: string, context: { firstName: string; lastName: string }) {
    super(message);
    this.firstName = context.firstName;
    this.lastName = context.lastName;
  }
}
